
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('pageContent', { feefo: 'getFeefo' }),
      rating () {
        return this.feefo.summary.rating.rating;
      },
      reviewCount () {
        return this.feefo.summary.meta.count;
      }
    }
  };
